import { sansSuite } from '@/api/devis/index';
import { TYPE_DEVIS } from '@/configuration/devisConf';
import validationSansSuite from '@/services/devisCommandes/validation/validationSansSuite';

export default async function devisSansSuiteMulti(devisToSansSuite) {
  const errors = [];
  const promises = [];
  if (!Array.isArray(devisToSansSuite)) return {};
  devisToSansSuite.forEach(devis => {
    promises.push(
      sansSuite(devis.id)
        .catch(e => {
          validationSansSuite(e.response, errors, TYPE_DEVIS, devis.code);
        }),
    );
  });
  const result = await Promise.all(promises);
  const nbDevisReussi = result.filter(r => r && r.status === 200).length;
  return { nbDevisReussi, errors };
}
